module.exports = __webpack_public_path__ + "static/media/Celebration-rafiki.483cf7f6.svg";